import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../shared/services/http-client/http-client.service';
import {
  CalendarioCampanhaResponseDto,
  CampanhaPlanoIntegracaoResponseDto,
  CreateCampanhaPlanoIntegracaoCommandDto,
  PerfilAmadeusResponseDto,
  PerfilPlanoParticipanteResponseDto,
  PlanoCalendarioResponseDto,
  UpdateCalendarioCampanhaRequestDto,
  UpdateCampanhaPlanoIntegracaoCommandDto,
} from '../api/models';

const CAMPANHA_BASE_PATH = '/v1/Campanha';
const PLANOS_BASE_PATH = '/v1/Planos';

@Injectable({
  providedIn: 'root',
})
export class DeParaIntegracaoApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  listPlanosIntegracao(idCampanha: number): Observable<CampanhaPlanoIntegracaoResponseDto[]> {
    return this.httpClient.get<CampanhaPlanoIntegracaoResponseDto[]>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/PlanosIntegracao`,
    );
  }

  createPlanoIntegracao(
    idCampanha: number,
    body: CreateCampanhaPlanoIntegracaoCommandDto,
  ): Observable<CampanhaPlanoIntegracaoResponseDto> {
    return this.httpClient.post<CampanhaPlanoIntegracaoResponseDto>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/PlanosIntegracao`,
      body,
    );
  }

  updatePlanoIntegracao(
    idCampanha: number,
    idPerfilInvest: number,
    numPlbnf: number,
    body: UpdateCampanhaPlanoIntegracaoCommandDto,
  ): Observable<CampanhaPlanoIntegracaoResponseDto> {
    return this.httpClient.put<CampanhaPlanoIntegracaoResponseDto>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/PlanosIntegracao/${idPerfilInvest}/${numPlbnf}`,
      body,
    );
  }

  deletePlanoIntegracao(
    idCampanha: number,
    idPerfilInvest: number,
    numPlbnf: number,
  ): Observable<string> {
    return this.httpClient.delete<string>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/PlanosIntegracao/${idPerfilInvest}/${numPlbnf}`,
    );
  }

  listPerfisPlanosParticipantes(idCampanha: number): Observable<PerfilPlanoParticipanteResponseDto[]> {
    return this.httpClient.get<PerfilPlanoParticipanteResponseDto[]>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/PerfisPlanosParticipantes`,
    );
  }

  listPerfisAmadeus(numPlbnf: number): Observable<PerfilAmadeusResponseDto[]> {
    return this.httpClient.get<PerfilAmadeusResponseDto[]>(
      `${PLANOS_BASE_PATH}/${numPlbnf}/PerfisAmadeus`,
    );
  }

  listCalendarios(idCampanha: number): Observable<CalendarioCampanhaResponseDto> {
    return this.httpClient.get<CalendarioCampanhaResponseDto>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/CalendariosFss`,
    );
  }

  salvarCalendario(
    idCampanha: number,
    body: UpdateCalendarioCampanhaRequestDto,
  ): Observable<PlanoCalendarioResponseDto> {
    return this.httpClient.put<PlanoCalendarioResponseDto>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/CalendarioIntegracao`,
      body,
    );
  }
}
